<template>
    
    <SubHeader title="Enregistrer un dossier reçu par courrier" :breads="[{name:'Nouveau Dossier'},{name:'Courrier'}]" />
    Dossier du jour
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"

export default {
    name: "DossierNewDossierJour",
    components:{
        SubHeader
    },

  


}
</script>